@if (hasLanguages()) {
  <span class="language-tracks" #languageOverlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
    <mat-icon aria-hidden="false" aria-label="Audio languages">audiotrack</mat-icon>
    <span>{{ audioLanguages().length }}</span>

    <mat-icon class="subtitle-icon" aria-hidden="false" aria-label="Subtitle languages">subtitles</mat-icon>
    <span>{{ subtitleLanguages().length }}</span>
  </span>

  <insight-popup-tooltip [overlayOrigin]="languageOverlayOrigin">
    <!-- in a template so the list is only built while the popup is open. There is one of
         these per order line, so building them all up front is wasted work -->
    <ng-template>
      <div class="language-list">
        <span class="language-list-label">Audio</span>
        @for (audioLanguage of audioLanguages(); track audioLanguage) {
          <div>{{ audioLanguage }}</div>
        } @empty {
          <div class="no-languages">None</div>
        }
      </div>

      <div class="language-list">
        <span class="language-list-label">Subtitles</span>
        @for (subtitleLanguage of subtitleLanguages(); track subtitleLanguage) {
          <div>{{ subtitleLanguage }}</div>
        } @empty {
          <div class="no-languages">None</div>
        }
      </div>
    </ng-template>
  </insight-popup-tooltip>
}
